{
  "recording-type": "Tipo de grabación",
  "mortgage-amount": "Monto",
  "tax-criteria": "Criterios fiscales",
  "sales-tax-rate": "Tasa de impuesto sobre las ventas"
}
